var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIhub(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 22",
    style: {
      enableBackground: "new 0 0 32 22"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32,0H16.7v10.5H32L32,0L32,0z M30.8,9.4h-13V1.2h13V9.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 2.2,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 3.1,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 4.2,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M19.4,4.7L19.4,4.7L19.5,5l0,0c-0.3,0.7-0.3,0.7-0.2,0.7l0.4,0.4c0,0,0,0,0.1,0c0,0,0.1,0,0.7-0.3l0,0l0.2,0.1 l0,0C20.9,6.6,21,6.6,21,6.6h0.5c0.1,0,0.1,0,0.3-0.7l0,0l0.2-0.1l0,0c0.4,0.2,0.6,0.2,0.7,0.2c0,0,0.1,0,0.1,0l0.4-0.4 c0,0,0.1-0.1-0.2-0.7l0,0l0.1-0.2l0,0c0.7-0.3,0.7-0.3,0.7-0.4V3.8c0-0.1,0-0.1-0.7-0.3l0,0l-0.1-0.2l0,0c0.3-0.7,0.3-0.7,0.2-0.7 l-0.4-0.4c0,0,0,0-0.1,0c0,0-0.1,0-0.7,0.3l0,0l-0.2-0.1l0,0c-0.3-0.7-0.3-0.7-0.4-0.7H21c-0.1,0-0.1,0-0.3,0.7l0,0l-0.2,0.1l0,0 c-0.4-0.2-0.6-0.2-0.7-0.2c0,0-0.1,0-0.1,0l-0.4,0.4c0,0-0.1,0.1,0.2,0.7l0,0l-0.1,0.2l0,0c-0.7,0.3-0.7,0.3-0.7,0.4v0.5 C18.7,4.5,18.7,4.5,19.4,4.7z M21.3,3.3c0.5,0,0.9,0.4,0.9,0.9c0,0.5-0.4,0.9-0.9,0.9s-0.9-0.4-0.9-0.9S20.8,3.3,21.3,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.8,6.4l-0.1,0.1l0,0c-0.2-0.1-0.3-0.1-0.4-0.1c0,0,0,0,0,0L23,6.5c0,0,0,0,0.1,0.4l0,0L23.1,7l0,0 c-0.4,0.1-0.4,0.2-0.4,0.2v0.3c0,0,0,0.1,0.4,0.2l0,0l0.1,0.1l0,0C23,8.2,23,8.2,23,8.2l0.2,0.2c0,0,0,0,0,0c0,0,0,0,0.4-0.1l0,0 l0.1,0.1l0,0C23.9,8.7,24,8.7,24,8.7h0.3c0,0,0.1,0,0.2-0.4l0,0l0.1-0.1l0,0C24.8,8.4,25,8.4,25,8.4c0,0,0,0,0,0l0.2-0.2 c0,0,0,0-0.1-0.4l0,0l0.1-0.1l0,0c0.4-0.1,0.4-0.2,0.4-0.2V7.2c0,0,0-0.1-0.4-0.2l0,0l-0.1-0.1l0,0c0.2-0.4,0.1-0.4,0.1-0.4L25,6.3 c0,0,0,0,0,0c0,0,0,0-0.4,0.1l0,0l-0.1,0l0,0C24.3,6,24.3,6,24.3,6H24C23.9,6,23.9,6,23.8,6.4L23.8,6.4z M24.1,6.9 c0.3,0,0.5,0.2,0.5,0.5s-0.2,0.5-0.5,0.5s-0.5-0.2-0.5-0.5S23.9,6.9,24.1,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M24.3,5.1L24.3,5.1L24.3,5.1L24.3,5.1c-0.1,0.3-0.1,0.3,0,0.3l0.1,0.1c0,0,0,0,0,0s0,0,0.2-0.1l0,0l0.1,0l0,0 c0.1,0.2,0.1,0.2,0.1,0.2h0.2c0,0,0,0,0.1-0.2l0,0l0.1,0l0,0c0.1,0.1,0.2,0.1,0.2,0.1c0,0,0,0,0,0l0.1-0.1c0,0,0,0-0.1-0.2l0,0 l0-0.1l0,0C25.9,5,25.9,5,25.9,5V4.8c0,0,0,0-0.2-0.1l0,0l0-0.1l0,0c0.1-0.2,0.1-0.2,0.1-0.2l-0.1-0.1c0,0,0,0,0,0s0,0-0.2,0.1l0,0 l-0.1,0l0,0C25.1,4,25.1,4,25.1,4h-0.2c0,0,0,0-0.1,0.2l0,0l-0.1,0l0,0c-0.1-0.1-0.2-0.1-0.2-0.1c0,0,0,0,0,0l-0.1,0.1 c0,0,0,0,0.1,0.2l0,0l0,0.1l0,0c-0.2,0.1-0.2,0.1-0.2,0.1V5C24.1,5,24.1,5,24.3,5.1z M25,4.6c0.2,0,0.3,0.1,0.3,0.3 c0,0.2-0.1,0.3-0.3,0.3c-0.2,0-0.3-0.1-0.3-0.3C24.7,4.7,24.8,4.6,25,4.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,22h15.3V11.5H0V22z M1.2,12.6h13v8.2h-13V12.6z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 13.9,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 14.8,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 15.9,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 15.1,
    className: "st0",
    width: 6.6,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 16.8,
    className: "st0",
    width: 5,
    height: 1.1
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 18.4,
    className: "st0",
    width: 9.9,
    height: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,11.4V22H32V11.4H16.7z M30.8,20.8h-13v-8.2h13V20.8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 13.6,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.8,
    y: 14.5,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 26.9,
    y: 15.6,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.1,19.3c0.2-0.2,0.6-1.5,0.6-1.5s-1.3,0.4-1.5,0.6c-0.2,0.2-0.2,0.6,0,0.9C22.4,19.5,22.8,19.5,23.1,19.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.7,20.2h7.9v-0.5l0,0c0-0.1,0-0.6,0-0.7c0-1.9-1.4-3-1.4-3c-0.7-0.6-1.6-1-2.6-1c-2.2,0-3.9,1.8-3.9,3.9 c0,0.1,0,0.6,0,0.7L18.7,20.2L18.7,20.2z M19.6,19h0.8v-0.3h-0.8c0,0-0.1,0-0.1,0c0-0.7,0.3-1.4,0.8-1.9l0,0l0,0l0.5,0.5l0.2-0.2 l-0.6-0.6c0.5-0.5,1.2-0.7,1.9-0.8h0c0,0,0,0,0,0v0.8h0.2v-0.8c0.1,0,0.2,0,0.3,0c0.6,0.1,1.2,0.3,1.6,0.8l-0.6,0.6l0.2,0.2 l0.5-0.5l0,0l0,0c0.5,0.5,0.7,1.2,0.8,1.9h-0.8V19l0.8,0c0,0,0,0.6,0,0.6l-6,0C19.6,19.6,19.6,19.1,19.6,19z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 28.6,
    cy: 19.2,
    r: 0.9
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 19.8,
    cy: 13.6,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 21.8,
    cy: 13.6,
    r: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 23.9,
    cy: 13.6,
    r: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,10.6h15.3V0H0V10.6z M1.2,1.2h13v8.2h-13V1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.4,2.4L5.8,4.1c0.5,0.1,0.8,0.6,0.8,1.1c0,0.3-0.1,0.5-0.2,0.7l1.4,1.1c0.4-0.5,0.6-1.1,0.6-1.8 C8.4,3.9,7.5,2.8,6.4,2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.2,6.4C4.6,6.4,4,5.9,4,5.3s0.5-1.2,1.2-1.2c0.1,0,0.2,0,0.3,0.1l0.5-1.6C5.8,2.4,5.5,2.4,5.2,2.4 c-1.6,0-2.9,1.3-2.9,2.9s1.3,2.9,2.9,2.9C6.1,8.2,7,7.7,7.5,7L6.1,6C5.9,6.2,5.6,6.4,5.2,6.4z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 2.4,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 3.4,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.2,
    y: 4.4,
    className: "st0",
    width: 3.2,
    height: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.6,5.7v0.9c0.3,0,0.6,0.3,0.6,0.6c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6c0,0,0,0,0,0h-0.9 c0,0,0,0,0,0c0,0.8,0.6,1.4,1.4,1.4c0.8,0,1.4-0.6,1.4-1.4C13.1,6.3,12.4,5.7,11.6,5.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIhub);
export default __webpack_public_path__ + "static/media/ihub.1f1b1d76b0935dc30f65d28db6b40c81.svg";
export { ForwardRef as ReactComponent };